import { useEffect, useState } from "react";
import { Button } from "@/components/ax/Button";
import { Field } from "@/components/ax/Field";
import { useI18n } from "@/i18n";
import { choiceDay, formatChoiceDate } from "@/lib/choiceDate";

export const ChooseByControl = ({ decision, onSave, disabled = false }) => {
  const { t, lang } = useI18n();
  const savedDay = choiceDay(decision.chooseBy);
  const [day, setDay] = useState(savedDay);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => setDay(savedDay), [savedDay]);
  const locked = !["draft", "composing", "ready"].includes(decision.status);
  const save = async () => {
    setBusy(true);
    setMessage("");
    const result = await onSave(day);
    setBusy(false);
    setMessage(result?.decision ? "saved" : "error");
  };
  return (
    <div data-testid={`choose-by-${decision.id}`} className="mt-3 min-w-0">
      {locked ? (
        <p className="m-0 text-sm leading-5 text-ax-muted" data-testid="choose-by-locked">
          {t("chooseBy.label")}: {formatChoiceDate(decision.chooseBy, lang) || t("chooseBy.empty")}
        </p>
      ) : (
        <>
          <Field type="date" label={t("chooseBy.label")} value={day}
            onChange={(e) => { setDay(e.target.value); setMessage(""); }}
            hint={day ? t("chooseBy.wib") : t("chooseBy.empty")}
            disabled={disabled || busy} testId="choose-by-input" />
          {day !== savedDay && <Button onClick={save} busy={busy} disabled={disabled || busy}
            data-testid="choose-by-save" className="mt-2">{t("chooseBy.save")}</Button>}
          {message && <p role={message === "error" ? "alert" : "status"}
            className={`m-0 mt-2 text-sm leading-5 ${message === "error" ? "text-ax-error" : "text-ax-muted"}`}>
            {t(message === "error" ? "chooseBy.error" : "chooseBy.saved")}
          </p>}
        </>
      )}
    </div>
  );
};
